import { createStore } from 'jotai';
import { layoutAtom, widgetPanelVisibilityAtom } from '@components/metrics-panel-hz/atoms';
import { summaryPanelAtom } from '@src/atoms/panels';
import { isTableCompareEnabledAtom } from '@components/dimension-panel-hz/atoms';
import { DISABLE_COMPARE_MODE_METRICS } from '@src/components/ai-alerts/constants';

function initStore({ alertMetric }: { alertMetric: string }) {
  const store = createStore();
  store.set(layoutAtom, '4s');
  store.set(summaryPanelAtom, false);
  store.set(widgetPanelVisibilityAtom, false);
  store.set(isTableCompareEnabledAtom, !DISABLE_COMPARE_MODE_METRICS.includes(alertMetric));
  return store;
}

export default initStore;
